// extracted by mini-css-extract-plugin
export var boxItems = "_8o-1";
export var boxItemsLg = "_8o-2";
export var button = "_8o-7";
export var buttonHoverless = "_8o-9";
export var buttonLg = "_8o-8";
export var filterGroupBox = "_8o-0";
export var icon = "_8o-3";
export var iconSecondary = "_8o-6";
export var iconWrapper = "_8o-4";
export var iconWrapperLg = "_8o-5";
export var truncatedLabel = "_8o-a";